import React from 'react'
import packageJson from '../package.json'
import moment from 'moment'
import { BUILD_DATE_ENDPOINT } from './constants/index'

const buildDateGreaterThan = (latestDate, currentDate) => {
  const momLatestDateTime = moment(latestDate)
  const momCurrentDateTime = moment(currentDate)
  if (momLatestDateTime.isAfter(momCurrentDateTime)) {
    return true
  } else {
    return false
  }
}
class CacheBuster extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        //console.log('-----------Clearing cache and hard reloading...')
        if (caches) {
          caches.keys().then(async function (names) {
            await Promise.all(names.map((name) => caches.delete(name)))
          })
        }
        // delete browser cache and hard reload
        window.location.reload()
      }
    }
  }

  componentDidMount() {
    // Auto reload UI if response from API build date is greater than UI build date from package.json.
    fetch(BUILD_DATE_ENDPOINT)
      .then((res) => res.json())
      .then((data) => {
        let latestVersion = 0

        if (data?.buildDate) latestVersion = Number(data.buildDate)

        if (typeof data === 'string') {
          try {
            const parsedData = JSON.parse(data)
            if (parsedData?.buildDate) latestVersion = Number(parsedData.buildDate)
          } catch (error) {
            console.error('Failed to parse buildDate: ', error)
          }
        }

        const currentVersion = packageJson.buildDate
        //console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^package json${currentVersion}`)
        //console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^BUILD_DATE_ENDPOINT${BUILD_DATE_ENDPOINT}${latestVersion}`)
        const shouldForceRefresh = buildDateGreaterThan(
          latestVersion,
          currentVersion
        )
        //console.log ('-------------shouldForceRefresh-->>', shouldForceRefresh)
        if (shouldForceRefresh) {
          //console.log(`We have a new version - ${latestVersion}. Should force refresh`)
          this.setState({ loading: false, isLatestVersion: false })
        } else {
          //console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`)
          this.setState({ loading: false, isLatestVersion: true })
        }
      })
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state
    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload
    })
  }
}
export default CacheBuster
